module.exports = __webpack_public_path__ + "static/media/font_bold.e52303c6.woff";